export default "__VITE_ASSET__CDdEIDET__"